import React from "react";
import { useNavigate } from "react-router-dom";
import {
  CalendarCheck, PhoneCall, Languages, LayoutDashboard, LineChart,
  Radar, Megaphone, Blocks, ShieldCheck, ArrowRight, Hospital,
} from "lucide-react";
import { Button } from "../ui/button";
import { Reveal, SectionHeading } from "../Reveal";
import { valueAdds } from "../../mock";

const iconMap = {
  CalendarCheck, PhoneCall, Languages, LayoutDashboard, LineChart,
  Radar, Megaphone, Blocks, ShieldCheck,
};

const ValueAddsTeaser = () => {
  const navigate = useNavigate();
  const open = (id) => {
    navigate(`/industries/healthcare#${id}`);
  };

  return (
    <section className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="Industries · Healthcare"
          title={<>Purpose-built for <span className="text-cyan-400">hospitals & clinics</span></>}
          sub="Nine healthcare-specific value adds that turn every patient call into better access, faster support and happier patients."
        />

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {valueAdds.map((v, i) => {
            const Icon = iconMap[v.icon];
            return (
              <Reveal key={v.id} delay={(i % 3) * 100}>
                <button
                  onClick={() => open(v.id)}
                  className="card-dark card-dark-hover group flex h-full w-full flex-col rounded-3xl p-6 text-left"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-cyan-400/20 bg-cyan-400/10">
                      <Icon className="h-5 w-5 text-cyan-300" />
                    </div>
                    <ArrowRight className="h-4 w-4 text-slate-600 transition-all duration-300 group-hover:translate-x-1 group-hover:text-cyan-300" />
                  </div>
                  <h3 className="font-display mt-5 text-base font-semibold text-white">{v.title}</h3>
                  <p className="mt-1.5 text-xs font-medium text-cyan-300/80">{v.tagline}</p>
                </button>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={150}>
          <div className="mt-12 flex justify-center">
            <Button
              size="lg"
              onClick={() => open("")}
              className="group rounded-full bg-cyan-400 px-8 font-semibold text-slate-950 transition-colors hover:bg-cyan-300"
            >
              <Hospital className="mr-2 h-4 w-4" />
              Explore the Healthcare Platform
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ValueAddsTeaser;
